import React, { useEffect } from 'react';
import { useState } from 'react';
import Button from '@material-ui/core/Button';
import { CustomInput } from '../common/SimpleInput';
import { useDispatch, useSelector } from 'react-redux';
import { postLogin } from '../../redux/authentication/thunks';
import logoBosch from '../../images/Bosch_logo.svg';
import { unwrapResult } from '@reduxjs/toolkit';
import { useHistory } from 'react-router';
import { ROUTE_PANEL } from '../routes/routesConstants';
import { openModal } from '../../redux/modal/modalSlice';
import { selectUserLoading } from '../../redux/authentication/selectors';
import { errorHandler } from '../../commonFunctions/errorHandler';

function Login(props) {
  const [user, setUser] = useState({ username: '', password: '' });
  const [error, setError] = useState({ username: undefined, password: undefined });
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectUserLoading);

  function handleUser(value, field) {
    setError({ ...error, [field]: undefined });
    setUser({ ...user, [field]: value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const resultAction = await dispatch(postLogin(user));
      const userData = unwrapResult(resultAction);
      localStorage.setItem('apoloCMRTK', userData.token);
      let redirectionUrl;
      if (props.location.state) {
        redirectionUrl = props.location.state.from + props.location.state.search;
      }
      history.push(redirectionUrl || ROUTE_PANEL);
    } catch (err) {
      if (err.message === 'USER_NOT_FOUND') {
        setError({ ...error, username: 'Credenciais inválidas. Por favor, tente novamente.' });
      } else if (err.message === 'INVALID_PASSWORD') {
        setError({ ...error, password: 'Credenciais inválidas. Por favor, tente novamente.' });
      } else {
        dispatch(openModal(errorHandler(err)));
      }
    }
  }

  function validateForm() {
    let valid = true;
    if (user.username === '') {
      setError((prevState) => ({
        ...prevState,
        username: 'Campo obrigatório',
      }));
      valid = false;
    }
    if (user.password === '') {
      setError((prevState) => ({
        ...prevState,
        password: 'Campo obrigatório',
      }));
      valid = false;
    }
    return valid;
  }

  return (
    <div className="login-section" style={{ height: window.innerHeight - 14 }}>
      <form onSubmit={handleSubmit} className="login-box">
        <div className="logo">
          <img src={logoBosch} alt="" />
        </div>
        <CustomInput type="text" label="Usuário *" value={user.username} onChange={(e) => handleUser(e, 'username')} error={error.username ? true : false} error_text={error.username} />
        <CustomInput type="password" label="Senha *" value={user.password} onChange={(e) => handleUser(e, 'password')} error={error.password ? true : false} error_text={error.password} />
        <Button type="submit" variant="contained" color="primary" onClick={handleSubmit} disabled={loading === 'loading' ? true : false}>
          Entrar
        </Button>
      </form>
    </div>
  );
}

export { Login };
